export const envIsProduction = location.hostname.toLowerCase() === 'cryptoalerts.com';
export const apiDomain = '';
export const apiUrl = `${apiDomain}/api/v1`;
export const sessionTokenCookiesName = 'session';
export const alertCreationLocalStorageName = 'alert-creation-data';
export const prevUrlLocalStorageName = 'prev-url';
export const currenciesTabLocalStorageName = 'currenciesTab';
export const sidePanelStateLocalStorageName = 'sidePanelState';
export const requestsIntervalForUnavailableServer = 30000; // ms
export const maxRequestsCountForUnavailableServer = 2;
export const apiTimeout = 120000; // ms
export const dateTimeFormat = 'MMMM D, hh:mm a';
export const shortDateFormat = 'MM/DD/YYYY';
export const shortMonthDateFormat = 'MMM/DD/YYYY';
export const dateFormat = 'MMMM D, YYYY';
export const shortMonthAndDayDateFormat = 'MMM D, YYYY';
export const tickersUpdateMinInterval = (1000 * 60) * 5; // ms
export const healthcheckMinInterval = 5000; // ms
export const notificationsUpdateMinInterval = 10000; // ms
export const userNotificationsUpdateMinInterval = 10000; // ms
export const recaptchaKey = '6LeZZl0UAAAAAGwDXKcM5y_LgpsxUoSejZT9Xjth';
export const minus = '\u2212';
export const logoutTimeout = 3000;
export const maxCountLoadingMoreBtn = 50;
export const limitTickersHomePage = 10;
export const defaultCurrencyCode = 'usd';
export const requestTypes = {
  get: 'get',
  post: 'post',
  put: 'put',
  delete: 'delete',
};
export const userMessages = {
  passwordResetSuccess: 'Password successfully changed. You can sign in with your new password.',
  passwordChangeSuccess: 'Password successfully changed.',
};
export const publicVapidKey = 'BDvTXFSAEhsL49prGRrh5i8NHhRi7CHP3SfqN83Z-AzYlEw1i28zInjb5mc6cT8aDbur1q00uwGZ1Vahy0KKxdA';
export const messagingSenderId = '461956647750';// if you want to change it, don't forget cmd+f 'messagingSenderId'
export const mobileWidth = 768;
export const stripeKey = 'pk_live_lpeRJ9uQPVFgEIgKvgosA26N';



// WEBPACK FOOTER //
// ./src/utils/config.js